SJ.WeatherManagement = class {
  constructor() {

    this.intensity = getRandom(0.15, 6.0);
    this.speed = getRandom(0.25, 0.9);

    this.type =
      SJ.V.weatherType === "null"
        ? "null"
        : getRandomWeatherType(SJ.V.weatherType);

    this.lightningsInterval = getRandom(5, 10) * 100;
    this.areLightningsEnabled = (getRandom(0, 1) <= 0.25) ? true : false;

    this.fogImg = SJ.ImageLoader.load("fog.png");

    if (SJ.Tools.cookieValue("weatherPernamentOff") === "true") {
      this.type = "null";
      this.areLightningsEnabled = false;

      // console.log(`%c !!! WEATHER TURNED OFF !!!`, 'color: red');
    }

    this.performanceCorectUpperLimit = 55;
    this.performanceCorectLowerLimit = 25;

    this.calculateIndicators();

    this.createWeather();
    this.createLightnigns();

    // console.log(`%c -----WEATHER VARIABLES-----`, 'color: orange');

    // console.log(`Weather type: ${this.type}`);
    // console.log(`Weather intensity: ${this.intensity}`);
    // console.log(`Weather speed: ${this.speed}`);
    // console.log(`Lightnings interval: ${this.lightningsInterval}`);
    // console.log(`Lightnings enabled: ${this.areLightningsEnabled}`);
    // console.log(`Weather status icon: ${this.weatherStatusIcon}`);
    // console.log(`Weather condition rating: ${this.weatherConditionRating}`);

    // console.log(``);
  }

  manage(keyCode) {
    if (keyCode === 84) {
      this.intensity = parseFloat(prompt("Podaj natężenie pogody"));
      this.createWeather();
    }

    if (keyCode === 89) {
      this.speed = parseFloat(prompt("Podaj prędkość opadów"));
      this.createWeather();
    }

    if (keyCode === 85) {
      const newType = prompt("Podaj typ opadów");

      if (newType === "off") {
        this.storm = null;
        this.weather = null;

        document.cookie = "weatherPernamentOff = true";
      }
      else if (newType === "on") {
        document.cookie = "weatherPernamentOff = false";

        this.createWeather();
        this.createLightnigns();
      }
      else if (newType !== 'null') {
        this.type = newType;

        this.createWeather();
      }
      else {
        this.weather = null;
      }
    }

    if (keyCode === 73) {
      this.areLightningsEnabled = true;
      this.strom = new Storm(
        parseInt(prompt("Podaj odstęp w wyświetlaniu piorunów"))
      );
    }

    if (keyCode === 79) {
      if (this.fog) this.fog = null;
      else this.createFog();
    }

    if (keyCode === 70) {
      if (this.fog)
        this.fog.alpha = parseInt(prompt("Podaj natężenie mgły(0-255)"));
    }
  }

  createWeather() {
    if (this.type !== "null")
      this.weather = new Weather(this.intensity, this.speed, this.type);

    if (this.type === 'rain') {

      if (this.speed * this.intensity < 3)
        SJ.weatherSoundContainer.play('lightRain');
      else
        SJ.weatherSoundContainer.play('heavyRain');

    }
  }

  resetParticlesPosition() {
    if (this.weather)
      this.weather.resetParticlesPosition();
  }

  createLightnigns() {
    if (this.areLightningsEnabled)
      this.storm = new Storm(this.lightningsInterval);
  }

  createFog() {
    this.fog = new Fog(this.fogImg);
  }

  setDefaultPercformanceCorrect() {
    if (this.weather) this.weather.performanceCorect = (this.intensity * 1000 * 30) / 100;
  }

  calculateIndicators() {
    this.weatherStatusIcon = 0;
    this.weatherConditionRating = 0;

    switch (this.type) {
      case "null": this.weatherStatusIcon = 1; break;
      case "rain": this.weatherStatusIcon = 3; break;
      case "snow": this.weatherStatusIcon = 5; break;
    }

    const v = this.speed * this.intensity;
    // console.log(`speed * intensity = ${v}`);

    if (this.type !== "null") {
      if (v < 0.5) this.weatherConditionRating = 1;
      else if (0.5 <= v && v < 1.5) this.weatherConditionRating = 2;
      else if (1.5 <= v && v < 3) this.weatherConditionRating = 3;
      else if (3 <= v && v < 4.5) this.weatherConditionRating = 4;
      else if (4.5 <= v) this.weatherConditionRating = 5;
    }

    if (this.areLightningsEnabled) {
      this.weatherStatusIcon += 1;
      this.weatherConditionRating += 1;
    }
  }

  update() {
    if (this.weather && this.type !== 'null') this.weather.update();
    if (this.storm) this.storm.update();
  }

  draw() {
    this.update();
    if (this.weather) this.weather.draw(this.performanceCorectUpperLimit, this.performanceCorectLowerLimit);

    if (this.storm) this.storm.draw();

    if (this.fog) this.fog.draw();
  }
};

class Weather {
  constructor(intensity, speed, type) {
    this.intensity = intensity * 1000;
    this.speed = speed;

    this.performanceCorect = this.intensity * 0.3;

    this.rainDrops = [];

    if (type === "rain") {
      for (let i = 0; i < this.intensity; i++)
        this.rainDrops[i] = new RainDrop(this.speed);
    } else if (type === "snow") {
      for (let i = 0; i < this.intensity; i++)
        this.rainDrops[i] = new Snowflake(this.speed);
    }
  }

  update() {
    if (this.performanceCorect > this.rainDrops.length)
      this.performanceCorect = this.rainDrops.length

    for (let i = 0; i < this.performanceCorect; i++) this.rainDrops[i].fall();
  }

  resetParticlesPosition() {
    for (let i = 0; i < this.intensity; i++) this.rainDrops[i].resetPosition();
  }

  draw(performanceCorectUpperLimit, performanceCorectLowerLimit) {
    for (let i = 0; i < this.performanceCorect; i++) this.rainDrops[i].draw();

    if (SJ.FPS > performanceCorectUpperLimit)
      this.performanceCorect += this.performanceCorect * 0.003;
    else if (SJ.FPS < performanceCorectLowerLimit)
      this.performanceCorect -= this.performanceCorect * 0.008;

    if (this.performanceCorect > this.intensity)
      this.performanceCorect = this.intensity;

    if (this.performanceCorect < 500)
      this.performanceCorect = 500;

    this.performanceCorect = Math.floor(this.performanceCorect);

    fill(0, 255, 0);
    text(this.performanceCorect, SJ.SCREEN_WIDTH - 250, 70);
  }
}

class Particle {
  constructor(speed) {
    this.color = color;

    // this.x = getRandom(SJ.camera._currentPosition.x - 500, SJ.SCREEN_WIDTH + SJ.camera._currentPosition.x);
    // this.y = getRandom(SJ.camera._currentPosition.y - 10, SJ.camera._currentPosition.y - 500);

    this.lastCameraX = SJ.camera._currentPosition.x;

    // this.x = getRandom(-200, SJ.SCREEN_WIDTH + 200);
    // this.y = getRandom(-200, SJ.SCREEN_HEIGHT);

    this.resetPosition();

    this.fallingSpeed = getRandom(3, 7) * speed;

    this.offset = {
      x: 200, y: -200
    }
  }

  resetPosition() {
    this.x = getRandom(0, SJ.SCREEN_WIDTH + 200);
    this.y = getRandom(-200, SJ.SCREEN_HEIGHT);
  }

  fall() {
    this.y += this.fallingSpeed;

    const cameraVelocity = SJ.camera._currentPosition.x - this.lastCameraX;
    if (cameraVelocity > 0)
      this.x -= cameraVelocity;

    this.lastCameraX = SJ.camera._currentPosition.x;

    if (this.y > SJ.SCREEN_HEIGHT + 10) {
      this.x = getRandom(0, SJ.SCREEN_WIDTH);
      this.y = getRandom(-50, -5);
    }
    if (this.x < 0) this.x = getRandom(SJ.SCREEN_WIDTH, SJ.SCREEN_WIDTH + 100);

    // if(this.y > SJ.SCREEN_HEIGHT + SJ.camera._currentPosition.y){
    //   this.x = getRandom(SJ.camera._currentPosition.x - 500, SJ.SCREEN_WIDTH + SJ.camera._currentPosition.x - 10);
    //   this.y = getRandom(SJ.camera._currentPosition.y - 10, SJ.camera._currentPosition.y - 500);
    // }

    // if(this.x < SJ.camera._currentPosition.x - 500){
    //   this.x = getRandom(SJ.camera._currentPosition.x - 500 + SJ.SCREEN_WIDTH, SJ.SCREEN_WIDTH + SJ.camera._currentPosition.x - 300);
    // }
  }

  draw() { }
}

class RainDrop extends Particle {
  constructor(speed) {
    super(speed);

    this.rainColor = color(74, 101, 131);

    this.width = getRandom(0.7, 2.5);
    this.height = getRandom(5, 10);
  }

  draw() {
    fill(this.rainColor);
    rect(this.x, this.y, this.width, this.height);
  }
}

class Snowflake extends Particle {
  constructor(speed) {
    super(speed);

    this.snowColor = color(255, 255, 255);

    this.size = getRandom(1, 4);
  }

  draw() {
    fill(this.snowColor);
    rect(this.x, this.y, this.size, this.size);
    // circle(this.x, this.y, this.size);
  }
}

class Storm {
  constructor(intensity) {
    this.intensity = intensity;

    this.color = color(255, 255, 255);
    this.alpha = 120;

    this.stormInterval = 0;

    this.lightning = new Lightning();
  }

  update() {
    if (this.lightning.lightningEnd) this.lightning = new Lightning();

    if (this.stormInterval < this.lightning.lightningLenght) {
      this.alpha = getRandom(0, 120);
    }

    this.stormInterval--;
    if (this.stormInterval < 0)
      this.stormInterval = getRandom(this.intensity, this.intensity + 400);
  }

  draw() {
    if (this.stormInterval < this.lightning.lightningLenght) {
      this.lightning.draw();
      this.color.setAlpha(this.alpha);
      fill(this.color);
      rect(0, 0, SJ.SCREEN_WIDTH, SJ.SCREEN_HEIGHT);
    }
  }
}

class Lightning {
  constructor() {
    this.lightningPoints = [];
    this.lightningPoints.push({ x: getRandom(0, SJ.SCREEN_WIDTH), y: -5 });

    this.lightningEnd = false;
    this.lightningLenght = 10
    this.lightningWeight = 4;
    this.lightningMinWeight = 3;

    this.strokeDectrement = (this.lightningWeight - this.lightningMinWeight) / this.lightningLenght;

    SJ.weatherSoundContainer.play(`${random(['lightning1', 'lightning2', 'lightning3', 'lightning4',])}`);

    this.draw();
  }

  setNextPoint() {

    const previousPointX = this.lightningPoints[this.lightningPoints.length - 1].x;
    const previousPointY = this.lightningPoints[this.lightningPoints.length - 1].y;

    const spread = {
      x: 150,
      y: getRandom(80, 110)
    }

    this.lightningPoints.push({
      x: getRandom(previousPointX - spread.x, previousPointX + spread.x),
      y: previousPointY + spread.y
    });

    if (this.lightningPoints.length > this.lightningLenght) this.lightningEnd = true;
  }

  draw() {
    if (!this.lightningEnd) {
      this.setNextPoint();
      this.setNextPoint();

      stroke(255, 255, 255);

      for (let i = 1; i < this.lightningPoints.length; i++) {
        strokeWeight(this.lightningWeight);
        // line(
        //   this.lightningPoints[i - 2].x,
        //   this.lightningPoints[i - 2].y,
        //   this.lightningPoints[i - 1].x,
        //   this.lightningPoints[i - 1].y
        //   )
        //   this.lightningWeight -= this.strokeDectrement;
        line(
          this.lightningPoints[i - 1].x,
          this.lightningPoints[i - 1].y,
          this.lightningPoints[i].x,
          this.lightningPoints[i].y
        )
        this.lightningWeight -= this.strokeDectrement;

      }

      noStroke();
    }
  }
}

class Fog {
  constructor(img) {
    this.img = img;

    this.color = color(115, 122, 133);
    this.alpha = 120;
  }

  draw() {
    this.color.setAlpha(this.alpha);
    fill(this.color);
    rect(0, 0, SJ.SCREEN_WIDTH, SJ.SCREEN_HEIGHT);
    // image(this.img, 0, 0);
  }
}

const getRandom = (min, max) => {
  return Math.random() * (max - min) + min;
};

const getRandomWeatherType = (types) => {
  let n = Math.floor(getRandom(0, 100));
  let c = 0;

  for (let i = 0; i < types.length; i++) {
    if (n <= types[i].probability + c) {
      return types[i].type;
    } else {
      c += types[i].probability;
    }
  }
};
